import _createForOfIteratorHelper from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import { createStyles, rem, getSize } from '@mantine/styles';
import { sizes } from '../SliderRoot/SliderRoot.styles.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var useStyles = createStyles(function (theme, _ref, _ref2) {
  var color = _ref.color,
      disabled = _ref.disabled,
      thumbSize = _ref.thumbSize;
  var size = _ref2.size;
  return {
    label: {
      position: "absolute",
      top: rem(-36),
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[9],
      fontSize: theme.fontSizes.xs,
      color: theme.white,
      padding: "calc(".concat(theme.spacing.xs, " / 2)"),
      borderRadius: theme.radius.sm,
      whiteSpace: "nowrap",
      pointerEvents: "none",
      userSelect: "none",
      touchAction: "none"
    },
    thumb: __spreadProps(__spreadValues({}, theme.fn.focusStyles()), {
      boxSizing: "border-box",
      position: "absolute",
      display: disabled ? "none" : "flex",
      height: thumbSize ? rem(thumbSize) : "calc(".concat(getSize({
        sizes,
        size
      }), " * 2)"),
      width: thumbSize ? rem(thumbSize) : "calc(".concat(getSize({
        sizes,
        size
      }), " * 2)"),
      backgroundColor: theme.colorScheme === "dark" ? theme.fn.themeColor(color, theme.fn.primaryShade()) : theme.white,
      border: "".concat(rem(4), " solid ").concat(theme.colorScheme === "dark" ? theme.white : theme.fn.themeColor(color, theme.fn.primaryShade())),
      color: theme.colorScheme === "dark" ? theme.white : theme.fn.themeColor(color, theme.fn.primaryShade()),
      transform: "translate(-50%, -50%)",
      top: "50%",
      cursor: "pointer",
      borderRadius: 1e3,
      alignItems: "center",
      justifyContent: "center",
      transitionDuration: "100ms",
      transitionProperty: "box-shadow, transform",
      transitionTimingFunction: theme.transitionTimingFunction,
      zIndex: 3,
      userSelect: "none",
      touchAction: "none"
    }),
    dragging: {
      transform: "translate(-50%, -50%) scale(1.05)",
      boxShadow: theme.shadows.sm
    }
  };
});
export default useStyles;